module.exports = __webpack_public_path__ + "static/media/website.5dcc1d58.png";